import { Injectable, OnDestroy } from '@angular/core';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { AbstractCRUDService } from '@campaign-portal/components-library';

@Injectable({
	providedIn: 'root'
})
export class RolesFieldsService implements AbstractCRUDService, OnDestroy {
	readonly entity = '';
	readonly title = '';

	readonly name: EntityField = {
		id: 0,
		name: 'users_roles.roles.name',
		variable: 'Name',
		filterType: FilterType.LIKE,
		required: true,
		type: InputType.TEXT
	};
	readonly rolePermissions: EntityField = {
		id: 1,
		name: 'users_roles.roles.rolePermissions',
		variable: 'Permissions',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: []
	};
	readonly user: EntityField = {
		id: 2,
		name: 'users_roles.roles.user',
		variable: 'Author',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};

	readonly headers: EntityField[] = [
		this.name,
		this.rolePermissions,
		this.user
	];
	readonly loading$ = new BehaviorSubject<boolean>(false);

	constructor() {
	}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
	}

	create(): Observable<void> {
		return of();
	}

	update(): Observable<void> {
		return of();
	}

	delete(): Observable<void> {
		return of();
	}

}
